import type { HierarchyRectangularNode } from 'd3-hierarchy';

import type { InternalTreeMapNode } from '../types/internal.js';

export const getNodeDimension = (
  entry: HierarchyRectangularNode<InternalTreeMapNode>,
): { width: number; height: number } => ({
  width: entry.x1 - entry.x0,
  height: entry.y1 - entry.y0,
});
